export const quotes = [
  'Be stubborn about your goals and flexible about your methods',
  'Think Big, trust yourself and make it happen',
  'Create your own opportunities',
  'Never stop learning',
];
